import { render, staticRenderFns } from "./GoodsConfigChoose.vue?vue&type=template&id=36431726&scoped=true"
import script from "./GoodsConfigChoose.vue?vue&type=script&lang=js"
export * from "./GoodsConfigChoose.vue?vue&type=script&lang=js"
import style0 from "./GoodsConfigChoose.vue?vue&type=style&index=0&id=36431726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36431726",
  null
  
)

export default component.exports